import { render, staticRenderFns } from "./CommentInputer.vue?vue&type=template&id=6da0d1a4&scoped=true"
import script from "./CommentInputer.vue?vue&type=script&lang=js"
export * from "./CommentInputer.vue?vue&type=script&lang=js"
import style0 from "./CommentInputer.vue?vue&type=style&index=0&id=6da0d1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da0d1a4",
  null
  
)

export default component.exports